import React from "react";
import { useRecommendedCategories } from "../hooks/useRecommendedCategories";
import { useRecommendations } from "../hooks/useRecommendations";
import { CategoryRecommendationCard } from "./RecommendationCard/CategoryRecommendationCard";
import { RecommendationCardSkeleton } from "./RecommendationCard/RecommendationCardSkeleton";
import { RecommendationCarousel } from "./RecommendationCarousel/RecommendationCarousel";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import SwiperClass from "swiper";

const SKELETON_COUNT = 4;

export const CategoriesRecommendationCarousel = () => {
  const { categories, isLoading, isError } = useRecommendedCategories();
  const { placeName } = useRecommendations();

  if (isError || (!isLoading && (!categories || categories.length === 0))) {
    return null;
  }

  const handleSlideChange = (swiper: SwiperClass) => {
    if (
      typeof window !== "undefined" &&
      (window as unknown as { dataLayer?: object[] }).dataLayer
    ) {
      (window as unknown as { dataLayer: object[] }).dataLayer.push({
        event: "carousel_scroll",
        carousel_name: "home_listposter_categories_recommendation",
        slide_index: swiper.activeIndex,
      });
    }
  };

  return (
    <RecommendationCarousel
      onSlideChange={handleSlideChange}
      title={
        <FormattedMessage
          id="recommendations.categories.title"
          defaultMessage="You might also need…"
        />
      }
      subtitle={
        placeName ? (
          <FormattedMessage
            id="recommendations.categories.subtitle.withPlace"
            defaultMessage="Often requested by people in {placeName}"
            values={{ placeName }}
          />
        ) : (
          <FormattedMessage
            id="recommendations.categories.subtitle.withoutPlace"
            defaultMessage="Often requested by people in your area"
          />
        )
      }
      slideWidth="215px"
      spaceBetween={16}
    >
      {isLoading
        ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
            <RecommendationCardSkeleton key={i} coverHeight="125px" />
          ))
        : categories?.map((category) => (
            <CategoryRecommendationCard key={category.name} {...category} />
          ))}
    </RecommendationCarousel>
  );
};
